import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Menu,
  MenuItem,
  Typography,
  useTheme,
  Box,
  IconButton,
} from "@mui/material";
import TabSelection from "./TabSelection";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BuildIcon from "@mui/icons-material/Build";
import { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../../axios/axios";
import Remediation_img from "../../assets/baseVersion/Remediation.svg";
import Audit_img from "../../assets/baseVersion/Audit_img.svg";
import References_img from "../../assets/baseVersion/References_img.svg";
import Rational_img from "../../assets/baseVersion/Rotional_img.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SkeletonLoader } from "../../modules/dashboard/shared";
import { set } from "lodash";

// import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentCopyIcon from "../../assets/copy_icon_sp.svg";
import ContentCopyDarkIcon from "../../assets/CopyContent_icon_dark.svg"

interface DetailsFlyoutProps {
  Total_Resources:
  | {
    devices_count: any;
    failed_count: any;
    passed_count: any;
    accepted_count: any;
  }
  | number;
  id: string;
  module?: string;
  isTotal?: boolean;
  parameterType?: string;
}

const DetailsFlyout = ({
  Total_Resources,
  id,
  module,
  isTotal,
  parameterType,
}: DetailsFlyoutProps) => {
  const isTemplate =
    parameterType?.toLowerCase() === "template" ||
    parameterType?.toLowerCase() === "custom";
  const [isRemediationexpanded, setIsRemediationExpanded] = useState(false);
  const [isAuditexpanded, setIsAuditExpanded] = useState(false);
  const [isRationaleexpanded, setIsRationaleExpanded] = useState(false);
  const [isReferencesexpanded, setIsReferencesExpanded] = useState(false);
  const [isAdditionalInformationexpanded, setIsAdditionalInformationExpanded] =
    useState(false);

  const [isdata, setData] = useState<any>();
  const [versionData, setVersionData] = useState<any>({});
  const [selectedValue, setSelectedValue] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isVendor, setIsVendor] = useState("");
  const [isOs, setIsOs] = useState("");
  const [isVersion, setIsVersion] = useState("");
  const [loading, setLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [tabsLoading, setTabsLoading] = useState(true);
  const [copyFeedback, setCopyFeedback] = useState<string | null>(null);
  const [copiedBlockId, setCopiedBlockId] = useState<string | null>(null);
  const [scrollContainerHeight, setScrollContainerHeight] = useState<string>("auto");
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const { scan_uuid } = useParams<{ scan_uuid: string }>();
  const location = useLocation();

  let moduleValue = module || "";

  if (!moduleValue) {
    if (
      location.pathname.includes("on-premises") ||
      location.pathname.includes("onprem")
    ) {
      moduleValue = "on_premise";
    } else {
      moduleValue = "cloud";
    }
  }

  const Details_Data = useSelector(
    (state: any) => state.OnPrem_DetailsSelectedTab.selectedButton
  );
  const selectedCategory = useSelector(
    (state: any) => state.OnPrem_DetailsSelectedTab.selectedCategory
  );
  // controls-by-parameter filters on category and control type. Unset (for example
  // right after a row click) keeps the previous Benchmark behaviour.
  const controlCategory: string = selectedCategory || "Benchmark";
  const isBenchmarkTab = controlCategory === "Benchmark";
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  console.log(Details_Data, "versionData");

  useEffect(() => {
    let isCancelled = false;

    const resolveModifiedByNames = async (items: any[]) => {
      const userIds = Array.from(
        new Set(
          items
            .map((item) => item?.last_modified_by)
            .filter((userId) => typeof userId === "string" && userId.trim())
        )
      );
      if (userIds.length === 0) return items;

      try {
        const usersResponse = await axiosInstance.post(
          "authentication/org-users",
          { type: 1 }
        );
        const users: any[] =
          usersResponse.data?.data?.users_list ||
          usersResponse.data?.users_list ||
          (Array.isArray(usersResponse.data?.data)
            ? usersResponse.data.data
            : []) ||
          [];

        const nameById = users.reduce((acc: Record<string, string>, user: any) => {
          const userId = String(user?.id || "");
          const firstName =
            user?.firstname || user?.first_name || user?.firstName || "";
          if (userId && firstName) acc[userId] = firstName;
          return acc;
        }, {});

        return items.map((item) => ({
          ...item,
          last_modified_by_name:
            nameById[String(item?.last_modified_by || "")] ||
            item?.last_modified_by,
        }));
      } catch (error) {
        console.error("Error fetching org users for modified by:", error);
        return items;
      }
    };

    const fetchTemplateData = async () => {
      if (!id || !isTemplate) return;

      setLoading(true);
      setIsReady(false);
      setData(null);

      try {
        const params: Record<string, string> = {
          parameter_name_id: id,
          control_type: "template",
          category_name: "Template",
          module: moduleValue,
        };
        if (scan_uuid) params.scan_summary_id = scan_uuid;

        const response = await axiosInstance.get(
          "securityscan/control-parameters",
          { params }
        );
        if (isCancelled) return;
        const rawData = response.data?.data || [];
        const enrichedData = await resolveModifiedByNames(rawData);
        if (isCancelled) return;
        setData(enrichedData);
      } catch (error) {
        console.error("Error fetching template control parameters:", error);
        if (!isCancelled) setData([]);
      } finally {
        if (!isCancelled) {
          setIsReady(true);
          setLoading(false);
        }
      }
    };

    if (isTemplate) {
      fetchTemplateData();
      return () => {
        isCancelled = true;
      };
    }
  }, [id, isTemplate, moduleValue, scan_uuid]);

  useEffect(() => {
    let isCancelled = false;

    const fetchData = async () => {
      if (!id || !Details_Data || !selectedCategory || isTemplate) return;

      setLoading(true);
      setIsReady(false);
      setData(null);

      try {
        if (moduleValue === "cloud") {
          try {
            if (!isCancelled) {
              setIsVendor("amazon web services");
              setSelectedValue("amazon web services");
            }
            const resolvedCategory = selectedCategory || "Benchmark";
            const response = await axiosInstance.get(
              "securityscan/controls-by-parameter",
              {
                params: {
                  control_type: Details_Data?.toUpperCase(),
                  category_name: resolvedCategory,
                  vendor: "amazon web services",
                  parameter_name_id: id,
                  module: moduleValue,
                },
              }
            );

            if (isCancelled) return;
            const payload = response.data?.data;
            const cloudControls = Array.isArray(payload)
              ? payload
              : Array.isArray(payload?.controls)
                ? payload.controls
                : Array.isArray(payload?.data)
                  ? payload.data
                  : payload
                    ? [payload]
                    : [];
            setData(cloudControls);
          } catch (error) {
            console.error("Error fetching data:", error);
            if (!isCancelled) setData([]);
          } finally {
            if (!isCancelled) setIsReady(true);
          }
          return;
        }

        const category_name = "Benchmark";
        const response = await axiosInstance.get(
          `securityscan/vendor-device-versions/${id}?module=${moduleValue}&category_name=${category_name}`
        );
        if (isCancelled) return;

        const cisBenchVersions = response?.data?.data;

        // vendor-device-versions lists Benchmark checks only, so a cloud Framework/MITRE
        // tab must not wait for it: cloud controls are fetched for the vendor as a whole.
        if (
          (cisBenchVersions && Object.keys(cisBenchVersions).length > 0) ||
          (moduleValue === "cloud" && !isBenchmarkTab)
        ) {
          if (moduleValue !== "cloud") {
            const filteredVersions: Record<
              string,
              Record<
                string,
                Array<{ version: string; control_display_name: string }>
              >
            > = {};

            Object.entries(cisBenchVersions).forEach(([vendor, osData]) => {
              const filteredOsData: Record<
                string,
                Array<{ version: string; control_display_name: string }>
              > = {};

              Object.entries(
                osData as Record<
                  string,
                  Array<{ version: string; control_display_name: string }>
                >
              ).forEach(([os, versions]) => {
                // A Benchmark tab keeps only its own checks' versions. Framework/MITRE
                // controls have no entry of their own here, so any of the parameter's
                // vendor/OS/version rows scopes them; list each version once.
                const matchingVersions = isBenchmarkTab
                  ? versions.filter(
                      (v) => v.control_display_name === Details_Data?.toUpperCase()
                    )
                  : versions.filter(
                      (v, i, all) => all.findIndex((o) => o.version === v.version) === i
                    );
                if (matchingVersions.length > 0) {
                  filteredOsData[os] = matchingVersions;
                }
              });

              if (Object.keys(filteredOsData).length > 0) {
                filteredVersions[vendor] = filteredOsData;
              }
            });

            if (isCancelled) return;
            setVersionData(filteredVersions);

            const firstValue = Object.entries(filteredVersions).flatMap(
              ([vendor, osData]) =>
                Object.entries(osData).flatMap(([os, versions]) =>
                  versions.map(
                    (versionObj) => `${vendor} - ${os} - ${versionObj.version}`
                  )
                )
            )[0];

            if (firstValue) {
              const [vendor, os, version] = firstValue
                .split(" - ")
                .map((v: string) => v.trim());
              if (!isCancelled) {
                setSelectedValue(firstValue);
                setIsVendor(vendor);
                setIsOs(os);
                setIsVersion(version);
              }
              try {
                const response = await axiosInstance.get(
                  "securityscan/controls-by-parameter",
                  {
                    params: {
                      control_type: Details_Data?.toUpperCase(),
                      category_name: controlCategory,
                      vendor: vendor,
                      model: os,
                      version: version,
                      parameter_name_id: id,
                      module: moduleValue,
                    },
                  }
                );

                if (isCancelled) return;
                setData(response.data?.data || []);
              } catch (error) {
                console.error("Error fetching data:", error);
                if (!isCancelled) setData([]);
              } finally {
                if (!isCancelled) setIsReady(true);
              }
            } else {
              // No matching filtered versions found
              if (!isCancelled) {
                setData([]);
                setIsReady(true);
              }
            }
          } else {
            try {
              if (!isCancelled) {
                setIsVendor("amazon web services");
                setSelectedValue("amazon web services");
              }
              const resolvedCategory = selectedCategory || "Benchmark";
              const response = await axiosInstance.get(
                "securityscan/controls-by-parameter",
                {
                  params: {
                    control_type: Details_Data?.toUpperCase(),
                    category_name: resolvedCategory,
                    vendor: "amazon web services",
                    parameter_name_id: id,
                    module: moduleValue,
                  },
                }
              );

              if (isCancelled) return;
              setData(response.data?.data || []);
            } catch (error) {
              console.error("Error fetching data:", error);
              if (!isCancelled) setData([]);
            } finally {
              if (!isCancelled) setIsReady(true);
            }
          }
        } else {
          if (!isCancelled) {
            setVersionData({});
            setData([]);
            setIsReady(true);
          }
        }
      } catch (error) {
        console.error("Error fetching CIS bench versions:", error);
        if (!isCancelled) {
          setVersionData({});
          setData([]);
          setIsReady(true);
        }
      } finally {
        if (!isCancelled) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isCancelled = true;
    };
  }, [id, Details_Data, selectedCategory, moduleValue, isTemplate]);

  // Note: isReady is already reset at the start of fetchData,
  // so no separate useEffect is needed. A separate useEffect would cause
  // a race condition by running after fetchData completes and resetting isReady back to false.

  // Calculate dynamic height for scrollable container based on its position
  useLayoutEffect(() => {
    const calculateHeight = () => {
      if (scrollContainerRef.current) {
        const rect = scrollContainerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const availableHeight = viewportHeight - rect.top - 20; // 20px bottom margin
        setScrollContainerHeight(`${Math.max(availableHeight, 200)}px`);
      }
    };

    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    return () => window.removeEventListener("resize", calculateHeight);
  }, [isReady, loading]);

  console.log(versionData, "versionDataversionDataversionData");

  // Flatten versionData into a simple list of "vendor - os - version" strings
  const versionOptions = React.useMemo(
    () =>
      Object.entries(versionData || {}).flatMap(([vendor, osData]) =>
        Object.entries(osData || {}).flatMap(([os, versions]) =>
          Array.isArray(versions)
            ? versions.map((versionObj: { version: string }) =>
                `${vendor} - ${os} - ${versionObj.version}`
              )
            : []
        )
      ),
    [versionData]
  );

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const activeSelectReqId = useRef(0);

  const handleSelectValue = async (value: string) => {
    const reqId = ++activeSelectReqId.current;
    const individualValues = value.split(" - ").map((v) => v.trim());

    setSelectedValue(value);
    const [vendor, os, version] = individualValues;
    if (individualValues) {
      setLoading(true);
      setIsReady(false);
      setData(null);
      try {
        const response = await axiosInstance.get(
          "securityscan/controls-by-parameter",
          {
            params: {
              control_type: Details_Data?.toUpperCase(),
              category_name: controlCategory,
              vendor: vendor,
              model: os,
              version: version,
              parameter_name_id: id,
              module: moduleValue,
            },
          }
        );

        if (reqId !== activeSelectReqId.current) return;
        setData(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        if (reqId === activeSelectReqId.current) setData([]);
      } finally {
        if (reqId === activeSelectReqId.current) {
          setIsReady(true);
          setLoading(false);
        }
      }

      if (reqId === activeSelectReqId.current) {
        setIsVendor(vendor);
        setIsOs(os);
        setIsVersion(version);
      }
    }

    handleMenuClose();
  };

  const attributeMappings: Record<string, Record<string, string>> = {
    SPARK: {
      name: "Spark Name",
      description: "Spark Descreption",
      remediation: "SPARK Remediation UI",
      audit: "SPARK Audit",
      rationale: "SPARK Rationale",
      references: "SPARK Reference",
    },
    CIS: {
      name: "CIS Name",
      description: "CIS Descreption UI",
      remediation: "CIS Remediation UI",
      audit: "CIS Audit UI",
      rationale: "CIS Rationale UI",
      references: "CIS Reference",
      level: "CIS Level",
    },
    DISA: {
      name: "DISA Name",
      description: "DISA Description",
      remediation: "DISA Remediation",
      audit: "DISA Audit",
      rationale: "DISA Rationale",
      references: "DISA Reference",
    },
    NIST: {
      name: "TITLE",
      description: "Discussion",
      remediation: "Remediation",
      audit: "Audit",
      rationale: "Security Requirement",
      references: "references",
      level: "Basic/Derived Security Requirement",
    },
    MITRE: {
      name: "name",
      description: "description",
      remediation: "mitigation",
      audit: "detection",
      rationale: "tactics",
      references: "url",
      level: "tactics",
    },
  };

  const scanType = Details_Data?.toUpperCase() || "SPARK"; // default fallback to SPARK
  const fieldMap = attributeMappings[scanType] || attributeMappings["SPARK"];

  const cleanAttribute = (value: unknown): string => {
    if (value === undefined || value === null) return "";
    const raw =
      typeof value === "string"
        ? value
        : Array.isArray(value)
        ? value.join(", ")
        : String(value);
    return raw.replace(/_x000D_/g, "");
  };

  const formatTemplateSectionUi = (sectionUi: any) => {
    if (!sectionUi || typeof sectionUi !== "object") return "";
    const parts: string[] = [];
    if (sectionUi.title) parts.push(sectionUi.title);
    if (sectionUi.description) parts.push(sectionUi.description);
    if (sectionUi.command) parts.push(`\`\`\`\n${sectionUi.command}\n\`\`\``);
    return parts.join("\n\n");
  };

  const mapTemplateToDetails = (item: any) => {
    const vendorModel = [item.vendor, item.device_model]
      .filter(Boolean)
      .join(" - ");
    const modifiedByName =
      item.last_modified_by_name || item.last_modified_by || "";
    const remediationContent =
      formatTemplateSectionUi(item.remediation_ui) ||
      (item.Remediation ? `\`\`\`\n${item.Remediation}\n\`\`\`` : "");
    const auditContent =
      formatTemplateSectionUi(item.audit_ui) ||
      (item.Audit ? `\`\`\`\n${item.Audit}\n\`\`\`` : "");
    const referenceParts = [
      item.template_name ? `Template name: ${item.template_name}` : "",
      item.last_modified
        ? `Last modified: ${new Date(item.last_modified).toLocaleString()}`
        : "",
      modifiedByName ? `Last modified by: ${modifiedByName}` : "",
    ].filter(Boolean);

    return {
      id: item.parameter_name_id,
      compliance_id: "",
      name:
        item.remediation_ui?.parent_command ||
        item.parent_command ||
        "Template Command",
      description: "",
      level: vendorModel || "N/A",
      remediation: remediationContent,
      hasChildCommands: Boolean(remediationContent),
      hasAuditInfo: Boolean(auditContent),
      hasReferences: referenceParts.length > 0,
      audit: auditContent,
      rationale: "",
      references: referenceParts.join("\n"),
      additional_information: "",
    };
  };

  const readCloudAttribute = (
    attributes: any,
    keys: Array<string | undefined>
  ) => {
    if (!attributes) return "";
    for (const key of keys) {
      if (!key) continue;
      const value = attributes[key];
      if (value && typeof value === "object" && !Array.isArray(value)) {
        const nested = value.Discussion || value.description || value.Description;
        if (nested) return nested;
      }
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        return value;
      }
    }
    return "";
  };

  const Scan_Details_Data = Array.isArray(isdata)
    ? isTemplate
      ? isdata.map(mapTemplateToDetails)
      : isdata.map((item: any) => {
          if (moduleValue !== "cloud") {
            return {
              id: item.id,
              compliance_id: item.version_number,
              name: cleanAttribute(item.attributes?.[fieldMap.name]),
              description: cleanAttribute(item.attributes?.[fieldMap.description]),
              level: item.attributes?.[fieldMap.level],
              remediation: cleanAttribute(item.attributes?.[fieldMap.remediation]),
              audit: cleanAttribute(item.attributes?.[fieldMap.audit]),
              rationale: cleanAttribute(item.attributes?.[fieldMap.rationale]),
              references: cleanAttribute(item.attributes?.[fieldMap.references]),
              additional_information: item.additional_information,
            };
          }

          const attributes = item.attributes || {};
          return {
            id: item.id || item.control_id,
            compliance_id: item.control_code || item.version_number,
            name: cleanAttribute(
              readCloudAttribute(attributes, [
                fieldMap.name,
                "Title",
                "TITLE",
                "Control Name",
                "CIS Name",
                "name",
              ])
            ),
            description: cleanAttribute(
              readCloudAttribute(attributes, [
                fieldMap.description,
                "Description",
                "DESCRIPTION",
                "CIS Descreption UI",
                "CIS Descreption",
                "Discussion",
                "Discussion2",
                "Purpose",
                "Section Name",
              ])
            ),
            level: readCloudAttribute(attributes, [
              fieldMap.level,
              "CIS Level",
              "Basic/Derived Security Requirement",
            ]),
            remediation: cleanAttribute(
              readCloudAttribute(attributes, [
                fieldMap.remediation,
                "CIS Remediation UI",
                "Remediation",
                "mitigation",
              ])
            ),
            audit: cleanAttribute(
              readCloudAttribute(attributes, [
                fieldMap.audit,
                "CIS Audit UI",
                "Audit",
                "detection",
              ])
            ),
            rationale: cleanAttribute(
              readCloudAttribute(attributes, [
                fieldMap.rationale,
                "CIS Rationale UI",
                "CIS Rationale",
                "Security Requirement",
              ])
            ),
            references: cleanAttribute(
              readCloudAttribute(attributes, [
                fieldMap.references,
                "CIS Reference",
                "references",
                "url",
              ])
            ),
            additional_information: item.additional_information,
            version: item.version_number,
            implementationGroups: [
              "Implementation Group 1",
              "Implementation Group 2",
              "Implementation Group 3",
            ]
              .filter(
                (key) => String(attributes[key] || "").trim().toLowerCase() === "x"
              )
              .map((key) => key.replace("Implementation Group ", "IG")),
          };
        })
    : [];

  function formatText(text: string, section: string = 'default') {
    if (!text) return null;

    // Clean up _x000D_ characters (carriage return in XML/HTML encoding)
    text = text.replace(/_x000D_/g, '');

    let processedText = text.replace(/([a-zA-Z])@@@/g, "$1___TEMP_AT_SIGN___");

    // Split the text into parts based on triple backticks (code blocks), @@@ patterns, triple single quotes, and single quotes
    // Updated to handle mixed quote delimiters (''...''', '''...''', ''...'', and '...')
    const parts = processedText.split(/(```[\s\S]*?```|''[^'@]*?@@@[\s\S]*?'''|''[^'@]*?'''|@@@[\s\S]*?@@@|'''[\s\S]*?'''|''[\s\S]*?''|'[^'\s@][\s\S]*?'|\*\*\*[\s\S]*?\*\*\*)/g);

    // Debug: log the parts to see what's being processed
    console.log('formatText parts:', parts);

    const handleCopyCode = async (codeContent: string, blockId: string) => {
      try {
        await navigator.clipboard.writeText(codeContent.trim());
        setCopiedBlockId(blockId);
        setCopyFeedback("✓ Copied!");
        setTimeout(() => {
          setCopyFeedback(null);
          setCopiedBlockId(null);
        }, 2000);
      } catch (err) {
        console.error('Failed to copy code: ', err);
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = codeContent.trim();
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          setCopiedBlockId(blockId);
          setCopyFeedback("✓ Copied!");
          setTimeout(() => {
            setCopyFeedback(null);
            setCopiedBlockId(null);
          }, 2000);
        } catch (fallbackErr) {
          console.error("Fallback copy failed: ", fallbackErr);
          setCopiedBlockId(blockId);
          setCopyFeedback("✗ Copy failed");
          setTimeout(() => {
            setCopyFeedback(null);
            setCopiedBlockId(null);
          }, 2000);
        }
        document.body.removeChild(textArea);
      }
    };

    return parts.map((part: string, index: number) => {
      if (index % 2 === 1) {
        // Code block from triple backticks, triple asterisks, @@@, triple single quotes, or double single quotes
        let codeContent = part;
        if (part.startsWith('```') && part.endsWith('```')) {
          codeContent = part.slice(3, -3); // Remove ``` from start and end
        } else if (part.startsWith("***") && part.endsWith("***")) {
          codeContent = part.slice(3, -3); // Remove *** from start and end
        } else if (part.startsWith("''") && part.endsWith("'''")) {
          codeContent = part.slice(3, -3); // Remove '' from start and ''' from end
        } else if (part.startsWith("'''") && part.endsWith("'''")) {
          codeContent = part.slice(3, -3); // Remove ''' from start and ''' from end
        } else if (part.startsWith('@@@') && part.endsWith('@@@')) {
          codeContent = part.slice(3, -3); // Remove @@@ from start and end
        } else if (part.startsWith("''") && part.endsWith("''")) {
          codeContent = part.slice(2, -2); // Remove '' from start and end
        } else if (part.startsWith("'") && part.endsWith("'") && part.length > 1) {
          codeContent = part.slice(1, -1); // Remove ' from start and end
        }

        const copyContent = codeContent.split('@@@')[1] || codeContent;
        codeContent = codeContent.replace(/@@@/g, "");

        const blockId = `${section}-${index}`;

        return (
          <div
            key={`codeblock-${blockId}`}
            style={{
              position: "relative",
              backgroundColor: isDarkMode ? "#transparent" : "#E5E5FC",
              borderRadius: "6px",
              margin: "12px 0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 8,
                right: 8,
                width: 20,
                height: 20,
                zIndex: 1,
                cursor: copiedBlockId === blockId ? "default" : "pointer",
                padding: "4px",
                borderRadius: "4px",
                // backgroundColor: isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)",
                transition: "background-color 0.2s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={copiedBlockId === blockId ? undefined : () => handleCopyCode(copyContent, blockId)}
              title={copiedBlockId === blockId ? "Copied!" : "Copy code"}
            >
              {copiedBlockId === blockId ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4CAF50"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ display: "block" }}
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                <img
                  src={isDarkMode ? ContentCopyDarkIcon : ContentCopyIcon}
                  alt="Copy"
                  style={{
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                    opacity: 0.4,
                    transition: "opacity 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = "1";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = "0.4";
                  }}
                />
              )}
            </div>
            <pre
              style={{
                backgroundColor: isDarkMode ? "#transparent" : "#E5E5FC",
                padding: "12px",
                paddingTop: "40px", // Extra padding to accommodate the copy button
                borderRadius: "6px",
                overflowX: "auto",
                overflowY: "auto",
                fontFamily: "monospace",
                fontSize: "13px",
                lineHeight: 1.4,
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                maxWidth: "100%",
                margin: 0,
              }}
            >
              <code style={{
                color: isDarkMode ? "#E6DB74" : "#2E7D32",
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                display: "block",
              }}>
                {codeContent.trim().replace(/___TEMP_AT_SIGN___/g, "@@@")}
              </code>
            </pre>
          </div>

        );
      } else {
        // Process regular text for bold formatting and other patterns
        const lines = part.split("\n");
        return lines.map((line: string, lineIndex: number) => {
          // Check if this line is a heading (starts with #)
          const headingMatch = line.match(/^(#+)\s+(.+)$/);
          if (headingMatch) {
            const headingLevel = headingMatch[1].length;
            const headingText = headingMatch[2];
            return (
              <div key={`heading-${index}-${lineIndex}`} style={{
                marginBottom: "8px",
                marginTop: "12px",
                fontWeight: "bold",
                fontSize: headingLevel === 1 ? "18px" : headingLevel === 2 ? "16px" : "14px",
                color: isDarkMode ? "#E0E0E0" : "#333333"
              }}>
                {headingText}
              </div>
            );
          }

          // Process bold text (**text**)
          const boldPattern = /\*\*(.*?)\*\*/g;
          const urlPattern = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+)/gi;
          const cisPattern = /(CIS Reference:\s?[^\s]+)/gi;
          const atPattern = /(@\S+)/g;
          // Hash pattern - but exclude command prompts like "hostname#command"
          const hashPattern = /(\s)(#[^\s]+)/g;

          // First, split by bold pattern
          const boldParts = line.split(boldPattern);

          // Debug: log bold parts to see if bold text is being detected
          if (boldParts.length > 1) {
            console.log('Bold parts detected:', boldParts);
          }

          return (
            <div key={`line-${index}-${lineIndex}`} style={{ marginBottom: "4px" }}>
              {boldParts.map((boldPart: string, boldIndex: number) => {
                if (boldIndex % 2 === 1) {
                  // This is bold text
                  return (
                    <strong key={`bold-${index}-${lineIndex}-${boldIndex}`}>
                      {boldPart}
                    </strong>
                  );
                } else {
                  // Process non-bold text for other patterns
                  const combinedPattern = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+|CIS Reference:\s?[^\s]+|@\S+|#[^\s]+)/g;
                  const subParts = boldPart.split(combinedPattern);

                  return subParts.map((sub: string, subIndex: number) => {
                    if (urlPattern.test(sub)) {
                      return (
                        <a
                          key={`url-${index}-${lineIndex}-${boldIndex}-${subIndex}`}
                          href={sub}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: isDarkMode ? "#90CAF9" : "#1976D2",
                            textDecoration: "underline",
                            wordBreak: "break-all"
                          }}
                        >
                          {sub}
                        </a>
                      );
                    } else if (cisPattern.test(sub)) {
                      const url = sub.replace("CIS Reference:", "").trim();
                      return (
                        <a
                          key={`cis-${index}-${lineIndex}-${boldIndex}-${subIndex}`}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: isDarkMode ? "#90CAF9" : "#1976D2",
                            textDecoration: "underline"
                          }}
                        >
                          {sub}
                        </a>
                      );
                    } else if (atPattern.test(sub)) {
                      // Extract content after @ symbol and clean up any delimiters or temporary markers
                      let cleanText = sub.replace(/^@+/, '').replace(/___TEMP_AT[A-Z_]*/g, '').replace(/@+$/, '');
                      return (
                        <code
                          key={`at-${index}-${lineIndex}-${boldIndex}-${subIndex}`}
                          style={{
                            backgroundColor: isDarkMode ? "#transparent" : "#E5E5FC",
                            padding: "2px 4px",
                            borderRadius: "4px",
                            fontFamily: "monospace",
                            marginRight: "4px",
                            color: isDarkMode ? "#E6DB74" : "#2E7D32",
                            wordBreak: "break-all",
                          }}
                        >
                          {cleanText}
                        </code>
                      );
                    } else if (hashPattern.test(sub)) {
                      return (
                        <React.Fragment key={`hash-${index}-${lineIndex}-${boldIndex}-${subIndex}`}>
                          <br />
                          <span>{sub.trim()}</span>
                        </React.Fragment>
                      );
                    } else {
                      return <span key={`text-${index}-${lineIndex}-${boldIndex}-${subIndex}`}>{sub}</span>;
                    }
                  });
                }
              })}
            </div>
          );
        });
      }
    });
  }

  return (
    <div style={{ paddingLeft: 15, paddingRight: 5 }}>
      {isTotal && (
        <>
          <div style={{ display: "flex", flexDirection: "row", gap: 40 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Total Resources
              </Typography>
              <span
                style={{ color: "#3A2ADA", fontWeight: 600, fontSize: "24px" }}
              >
                {typeof Total_Resources === 'object' ? Total_Resources?.devices_count : 0}
              </span>
            </div>
            <Divider
              variant="middle"
              orientation="vertical"
              flexItem
              sx={{ height: "50px", color: "#D2D2F6" }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Failed
              </Typography>
              <span
                style={{ color: "#F53B3B", fontWeight: 600, fontSize: "24px" }}
              >
                {typeof Total_Resources === 'object' ? Total_Resources?.failed_count : 0}
              </span>
            </div>
            <Divider variant="middle" orientation="vertical" flexItem />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 15,
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Pass
              </Typography>
              <span
                style={{ color: "#00A61B", fontWeight: 600, fontSize: "24px" }}
              >
                {typeof Total_Resources === 'object' ? Total_Resources?.passed_count : 0}
              </span>
            </div>
            <Divider variant="middle" orientation="vertical" flexItem />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 15,
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                Accepted Risk
              </Typography>
              <span
                style={{ color: "#BB2B3D", fontWeight: 600, fontSize: "24px" }}
              >
                {isTemplate
                  ? "N/A"
                  : typeof Total_Resources === "object"
                    ? Total_Resources?.accepted_count
                    : 0}
              </span>
            </div>
          </div>
        </>
      )}

      <>
          <Divider sx={{ mb: 2 }} />
          <div
            style={{
              marginBottom: 10,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <TabSelection setLoading={setLoading} setTabsLoading={setTabsLoading} module={module} id={id} parameterType={parameterType} />
        {!isTemplate && (
        <FormControl sx={{ width: "150px" }}>
          <Button
            variant="outlined"
            onClick={versionOptions.length > 1 ? handleMenuOpen : undefined}
            endIcon={
              versionOptions.length > 1 ? <KeyboardArrowDownIcon /> : undefined
            }
            sx={{
              backgroundColor: isDarkMode ? "#1E1E1E" : "#FFFFFF",
              color: isDarkMode ? "white" : "#3A2ADA",
              fontWeight: "bold",
              cursor: versionOptions.length > 1 ? "pointer" : "default",
              justifyContent: "space-between",
              textTransform: "none",
              borderColor: isDarkMode ? "#3A3A3A" : "#D0D5DD",
              "&:hover": {
                backgroundColor: isDarkMode ? "#2A2A2A" : "#F3F4F6",
                borderColor: isDarkMode ? "#4A4A4A" : "#98A2B3",
                color: isDarkMode ? "white" : "#3A2ADA",
              },
            }}
          >
            {selectedValue || "Select Version"}
          </Button>
          {moduleValue !== "cloud" && versionOptions.length > 1 && (
            <>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: isDarkMode ? "#1E1E1E" : "#F8F8FF", // Dropdown background
                    borderRadius: "4px", // Rounded corners
                    boxShadow: "0px 4px 5px rgba(0, 0, 0, 0.25)", // Shadow for the dropdown
                  },
                }}
              >
                {versionOptions.map((combinedValue) => (
                  <MenuItem
                    key={combinedValue}
                    onClick={() => handleSelectValue(combinedValue)}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#E0E0FF", // Hover effect for menu items
                        color: "#3A2ADA", // Text color on hover
                      },
                      fontWeight: "bold",
                    }}
                  >
                    {combinedValue}
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}
        </FormControl>
        )}
      </div>
      <div>
        <Divider sx={{ mb: 2 }} />
        {!isReady || loading || (!isTemplate && tabsLoading) || !isdata ? (
          <Box>
            <SkeletonLoader
              count={Math.floor(window.innerHeight / 45)}
              styles={{ height: 20 }}
            />
          </Box>
        ) : isdata && isdata.length > 0 ? (
          <Box
            ref={scrollContainerRef}
            sx={{
              ...( (location.pathname.includes("on-premises/assets") ||
                    location.pathname.includes("asset_v2") ||
                    location.pathname.includes("asset") ||
                    location.pathname === "/dashboard" ||
                    location.pathname.includes("cloud/cloud-resources") ||
                    location.pathname.includes("on-premises/cve") ||
                    !location.pathname.includes("security-posture"))
                  ? {
                      overflowY: "auto",
                      overflowX: "hidden",
                      height: scrollContainerHeight,
                      scrollbarWidth: "none", // Firefox
                      msOverflowStyle: "none", // IE and Edge
                      "&::-webkit-scrollbar": {
                        display: "none", // Chrome, Safari, Opera
                        width: 0,
                        height: 0,
                      },
                    }
                  : {} ),
            }}
          >
            {Scan_Details_Data.slice(0, 1).map((detail: any, detailIndex: number) => (
            <div key={`${detail?.id || detail?.compliance_id || "control"}-${detailIndex}`}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: 10,
                marginBottom: 5,
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                {detail?.compliance_id && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#3A2ADA",
                      fontWeight: "bolder",
                      fontSize: "16px",
                    }}
                  >
                    <span
                      style={{
                        backgroundColor: isDarkMode ? "#1E1E1E" : "#B6B6B626",
                        padding: 5,
                        borderRadius: 4,
                      }}
                    >
                      {detail?.compliance_id}
                    </span>
                  </Typography>
                )}
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  {detail?.name}
                </Typography>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                {moduleValue === "cloud" && detail?.version && (
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      color: "#3A2ADA",
                      backgroundColor: "#1103C014",
                      padding: 1,
                      borderRadius: 1,
                      textWrap: "nowrap",
                    }}
                  >
                    Version {detail.version}
                  </Typography>
                )}
                {(moduleValue !== "cloud" || detail?.level) && (
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "14px",
                      color: "#3A2ADA",
                      backgroundColor: "#1103C014",
                      padding: 1,
                      borderRadius: 1,
                      textWrap: "nowrap",
                    }}
                  >
                    {detail?.level || "N/A"}
                  </Typography>
                )}
              </div>
            </div>
            {moduleValue === "cloud" && detail?.implementationGroups?.length > 0 && (
              <div style={{ display: "flex", flexDirection: "row", gap: 12, marginBottom: 8 }}>
                {detail.implementationGroups.map((group: string) => (
                  <Typography key={group} variant="body2" sx={{ fontWeight: "bold" }}>
                    {group}
                  </Typography>
                ))}
              </div>
            )}
            {detail?.description && (
              <Typography variant="body2" sx={{ color: "#716DA0", mb: 2 }}>
                {detail?.description}
              </Typography>
            )}
            {(detail?.remediation || isTemplate) && (
              <Accordion
                expanded={isRemediationexpanded}
                onChange={() =>
                  setIsRemediationExpanded(!isRemediationexpanded)
                }
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  mb: 0.5,
                  "& .MuiAccordionSummary-root": {
                    minHeight: "40px",
                    "& .MuiTypography-subtitle1": {
                      fontSize: "14px",
                    },
                  },
                  "& .MuiAccordionDetails-root": {
                    pt: 0.5,
                    pb: 1,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={Remediation_img}
                        alt=""
                        style={{ width: 16, height: 16 }}
                      />
                    </div>

                    <Typography variant="subtitle1" fontWeight="bold">
                      Remediation:
                    </Typography>
                  </div>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                    overflow: "hidden",
                    padding: "4px 16px",
                    "& .MuiTypography-root": {
                      fontSize: "13px",
                      lineHeight: 1.5,
                    },
                  }}
                >
                  {isTemplate && !detail?.hasChildCommands ? (
                    <Typography variant="body2" sx={{ color: "#716DA0" }}>
                      No remediation details are available for this template.
                    </Typography>
                  ) : (
                    formatText(detail?.remediation, 'remediation')
                  )}
                </AccordionDetails>
              </Accordion>
            )}

            {(detail?.audit || isTemplate) && (
              <Accordion
                expanded={isAuditexpanded}
                onChange={() => setIsAuditExpanded(!isAuditexpanded)}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  mb: 0.5,
                  "& .MuiAccordionSummary-root": {
                    minHeight: "40px",
                    "& .MuiTypography-subtitle1": {
                      fontSize: "14px",
                    },
                  },
                  "& .MuiAccordionDetails-root": {
                    pt: 0.5,
                    pb: 1,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={Audit_img}
                        alt=""
                        style={{ width: 16, height: 16 }}
                      />
                    </div>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Audit:
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                    padding: "4px 16px",
                    "& .MuiTypography-root": {
                      fontSize: "13px",
                      lineHeight: 1.5,
                    },
                  }}
                >
                  {isTemplate && !detail?.hasAuditInfo ? (
                    <Typography variant="body2" sx={{ color: "#716DA0" }}>
                      No audit details are available for this template.
                    </Typography>
                  ) : (
                    formatText(detail?.audit, 'audit')
                  )}
                </AccordionDetails>
              </Accordion>
            )}

            {!isTemplate && detail?.rationale && (
              <Accordion
                expanded={isRationaleexpanded}
                onChange={() => setIsRationaleExpanded(!isRationaleexpanded)}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  mb: 0.5,
                  "& .MuiAccordionSummary-root": {
                    minHeight: "40px",
                    "& .MuiTypography-subtitle1": {
                      fontSize: "14px",
                    },
                  },
                  "& .MuiAccordionDetails-root": {
                    pt: 0.5,
                    pb: 1,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={Rational_img}
                        alt=""
                        style={{ width: 16, height: 16 }}
                      />
                    </div>
                    <Typography variant="subtitle1" fontWeight="bold">
                      Rationale:
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                    padding: "4px 16px",
                    "& .MuiTypography-root": {
                      fontSize: "13px",
                      lineHeight: 1.5,
                    },
                  }}
                >
                  {formatText(detail?.rationale, 'rationale')}
                </AccordionDetails>
              </Accordion>
            )}

            {(detail?.references || isTemplate) && (
              <Accordion
                expanded={isReferencesexpanded}
                onChange={() => setIsReferencesExpanded(!isReferencesexpanded)}
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  mb: 0.5,
                  "& .MuiAccordionSummary-root": {
                    minHeight: "40px",
                    "& .MuiTypography-subtitle1": {
                      fontSize: "14px",
                    },
                  },
                  "& .MuiAccordionDetails-root": {
                    pt: 0.5,
                    pb: 1,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    borderRadius: "8px",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={References_img}
                        alt=""
                        style={{ width: 16, height: 16 }}
                      />
                    </div>
                    <Typography variant="subtitle1" fontWeight="bold">
                      References:
                    </Typography>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    bgcolor: isDarkMode ? "transparent" : "#F8F8FF",
                    padding: "4px 16px",
                    "& .MuiTypography-root": {
                      fontSize: "13px",
                      lineHeight: 1.5,
                    },
                  }}
                >
                  {isTemplate && !detail?.hasReferences ? (
                    <Typography variant="body2" sx={{ color: "#716DA0" }}>
                      No references are available for this template.
                    </Typography>
                  ) : (
                    formatText(detail?.references, 'references')
                  )}
                </AccordionDetails>
              </Accordion>
            )}
            {!isTemplate && detail?.additional_information && (
              <Accordion
                expanded={isAdditionalInformationexpanded}
                onChange={() =>
                  setIsAdditionalInformationExpanded(
                    !isAdditionalInformationexpanded
                  )
                }
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                  "& .MuiAccordionSummary-root": {
                    minHeight: "40px",
                    "& .MuiTypography-subtitle1": {
                      fontSize: "14px",
                    },
                  },
                  "& .MuiAccordionDetails-root": {
                    pt: 0.5,
                    pb: 1,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ borderRadius: "8px" }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    Additional Information:
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    borderRadius: "8px",
                    overflow: "hidden",
                    padding: "4px 16px",
                    "& .MuiTypography-root": {
                      fontSize: "13px",
                      lineHeight: 1.5,
                    },
                  }}
                >
                  {formatText(detail?.additional_information, 'additional_information')}
                </AccordionDetails>
              </Accordion>
            )}
            </div>
            ))}
          </Box>
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: "000", // Red color for the message
              textAlign: "center",
              marginTop: 20,
            }}
          >
            No data found
          </Typography>
        )}
      </div>
      </>
    </div>
  );
};

export default DetailsFlyout;
